import {
    deleteDataApi,
    getDataApi,
    postDataApi,
    putDataApi,
} from '../utils/fech-api';

const BASE_URL_EMISSIONS = '/api/emissions';
export const BASE_URL_EMISSION_Manage = '/api/admin/emissions';

// Fetch all emissions
export const fetchEmissions = async ({ pageParam = 1, params = {}, headers = {} }) => {
    const resp = await getDataApi(BASE_URL_EMISSIONS, headers, { ...params, page: pageParam });
    return ({
        data: resp.data,
        nextPage: resp.data.length > 0 ? pageParam + 1 : undefined,
    });
};

// Fetch a single emission by ID
export const fetchEmissionById = (emissionId, headers = {}) => {
    return getDataApi(`${BASE_URL_EMISSIONS}/${emissionId}`, headers);
};

// Create a new emission
export const createEmission = (postData, headers = {}) => {
    return postDataApi(BASE_URL_EMISSION_Manage, postData, headers);
};

// Update an emission (PUT request)
export const updateEmission = (postId, updatedData, headers = {}) => {
    return putDataApi(`${BASE_URL_EMISSION_Manage}/${postId}`, updatedData, headers);
};


// Delete an emission
export const deleteEmission = (emissionId, headers = {}, params = {}) => {
    return deleteDataApi(`${BASE_URL_EMISSION_Manage}/${emissionId}`, headers, params);
};
